module.exports = __webpack_public_path__ + "media/images/emblems/Sankt_Stephan-coat_of_arms-469089f8f31f17c5552de1385d8bd413.svg";